import React from "react";
import { customerFullName } from "../shared/customerProfile";

export default function CustomerProfileFields({ value, onChange }) {
  const setField = (field, next) => onChange((previous) => ({ ...previous, [field]: next }));
  const inputClass = "mt-1 w-full rounded-xl border border-white/20 bg-slate-800 px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-amber-400";
  return (
    <div className="grid grid-cols-1 gap-4 rounded-2xl bg-slate-900 p-4 text-white md:grid-cols-2">
      <label className="text-sm font-semibold text-white">
        Civilité
        <select value={value.civility} onChange={(event) => setField("civility", event.target.value)} className={inputClass} required>
          <option value="Mr">Monsieur</option>
          <option value="Mme">Madame</option>
        </select>
      </label>
      <label className="text-sm font-semibold text-white">
        Téléphone (facultatif)
        <input type="tel" autoComplete="tel" value={value.phone || ""} onChange={(event) => setField("phone", event.target.value)} className={inputClass} />
      </label>
      <label className="text-sm font-semibold text-white md:col-span-2">
        Nom &amp; Prénom *
        <input autoComplete="name" value={value.full_name ?? customerFullName(value)} onChange={(event) => setField("full_name", event.target.value)} className={inputClass} required />
      </label>
      <label className="text-sm font-semibold text-white md:col-span-2">
        Date de naissance
        <input type="date" value={value.birth_date || ""} onChange={(event) => setField("birth_date", event.target.value)} className={inputClass} />
      </label>
    </div>
  );
}
